import React from 'react';

const News = props => {

  return (
    <section id="berita" className="product-benefits">
      <div className="product-benefits-group">
        <div className="product-benefit-1-tagline">
          Here is product benefit 1. Isn't it amazing?
        </div>
        <div className="product-benefit-1-image"></div>
        <div className="product-benefit-2-tagline">
          Here is product benefit 2. I can do this all day long.
        </div>
        <div className="product-benefit-2-image"></div>
        <div className="product-benefit-3-tagline">
          Boom. Product benefit 3. Kills any last remaining doubts no?
        </div>
        <div className="product-benefit-3-image"></div>
      </div>
    </section>
  )
};

export default News;
